import App from '@components/App'
import { useCallback, useEffect, useState } from 'react'

import { ChoicesProvider } from '@/contexts/choices'
import { ConfigProvider } from '@/contexts/config'
import { ConsultationProvider } from '@/contexts/consultation'
import { ErrorsProvider } from '@/contexts/error'
import { SurveysProvider } from '@/contexts/indications'
import { JourneyProvider } from '@/contexts/journey'
import { LoadingProvider } from '@/contexts/loading'
import { ModalProvider } from '@/contexts/modal'
import { NavigatorProvider } from '@/contexts/navigator'
import { ToastProvider } from '@/contexts/toast'
import { UserProvider } from '@/contexts/user'
import { UserFormProvider } from '@/contexts/userForm'
import { WebsocketProvider } from '@/contexts/websocket'

export const Root = () => {
  const [error, setError] = useState('')
  if (error) throw error

  const promiseRejectionHandler = useCallback((event: PromiseRejectionEvent) => {
    setError(event.reason)
  }, [])

  useEffect(() => {
    window.addEventListener('unhandledrejection', promiseRejectionHandler)

    return () => {
      window.removeEventListener('unhandledrejection', promiseRejectionHandler)
    }
  }, [])

  return (
    <ToastProvider>
      <ConfigProvider>
        <ModalProvider>
          <UserProvider>
            <ChoicesProvider>
              <ErrorsProvider>
                <LoadingProvider>
                  <JourneyProvider>
                    <UserFormProvider>
                      <ConsultationProvider>
                        <SurveysProvider>
                          <NavigatorProvider>
                            <WebsocketProvider>
                              <App />
                            </WebsocketProvider>
                          </NavigatorProvider>
                        </SurveysProvider>
                      </ConsultationProvider>
                    </UserFormProvider>
                  </JourneyProvider>
                </LoadingProvider>
              </ErrorsProvider>
            </ChoicesProvider>
          </UserProvider>
        </ModalProvider>
      </ConfigProvider>
    </ToastProvider>
  )
}
